export default "__VITE_ASSET__DPvagw54__"